import { QUOTES_CODE_MAPPING } from '@/constants/quote';

export const reverseHistory = ({ t, c }: { t: any; c: any }) => {
  if (!t || !c) {
    return {
      c: [],
      t: []
    };
  }

  return {
    c: [...c].reverse(),
    t: [...t].reverse()
  };
};

export const getBaseline = ({ quote, c }: { quote: any; c: any }) => {
  if (quote) {
    const prevClosePrice = quote[QUOTES_CODE_MAPPING.LastClose];

    if (prevClosePrice) {
      return prevClosePrice;
    }
  }

  if (c && c.length) {
    return c[0];
  }

  return 0;
};

export const getLastUpdateTimestamp = ({ t, c }: { t: any; c: any }) => {
  if (!t || !t.length || !c || !c.length) {
    return {
      lastUpdateTimestamp: null,
      lastPrice: null
    };
  }

  return {
    lastUpdateTimestamp: t[t.length - 1],
    lastPrice: c[c.length - 1]
  };
};

export const getChartUpdateKey = ({ windowSize, lastUpdateTimestamp, lastPrice, isTrading }: any) => {
  // set updateKey to falsy to prevent generate SVG
  if (!lastUpdateTimestamp) {
    return '';
  }

  const isWindowSizeLarge = windowSize === 'large';

  // repaint SVGChart when
  // 1. lastUpdateTimestamp change (received new data)
  // 2. lastPrice change
  // 3. window size change
  // 4. isTrading change
  return lastUpdateTimestamp + lastPrice + isWindowSizeLarge + !!isTrading;
};
